import { render, staticRenderFns } from "./perseo_tabla_avanzada.vue?vue&type=template&id=2a44b83a&scoped=true"
import script from "./perseo_tabla_avanzada.vue?vue&type=script&lang=js"
export * from "./perseo_tabla_avanzada.vue?vue&type=script&lang=js"
import style0 from "./perseo_tabla_avanzada.vue?vue&type=style&index=0&id=2a44b83a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44b83a",
  null
  
)

export default component.exports